import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography"
import { twMerge } from "tailwind-merge"

const ContentSection = ({ title, description, className }) => (
  <div
    className={twMerge(
      "flex flex-col w-full md:max-w-[628px] lg:max-w-[540px] items-center lg:items-start justify-center gap-[16px] md:gap-[30px] mx-auto",
      className
    )}
  >
    <Typography
      component="h2"
      variant="h1"
      className="text-center lg:text-left"
    >
      {title}
    </Typography>
    <Typography variant="body1" className="text-center lg:text-left">
      {description}
    </Typography>
  </div>
)

const ImageSection = ({ image, title, className }) => (
  <div className={twMerge("flex justify-center w-full md:w-auto", className)}>
    <img
      src={image}
      alt={title}
      className="w-full md:w-auto md:h-[580px] object-contain"
    />
  </div>
)

const FeatureLayout = ({ item, isImageRight = false }) => {
  const contentOrderClass = isImageRight ? "lg:order-2" : "lg:order-1"
  const imageOrderClass = isImageRight ? "lg:order-1" : "lg:order-2"

  return (
    <div className="w-full px-[16px] md:px-px1_l xl:px-px1_xl mt-[50px] md:mt-[70px] lg:mt-0">
      <div className="flex flex-col lg:flex-row w-full max-w-[580px] md:max-w-w2_xl items-center justify-center gap-[30px] md:gap-[40px] lg:gap-[80px] mx-auto lg:py-[56px]">
        <div className={twMerge("w-full lg:w-1/2 order-1", contentOrderClass)}>
          <ContentSection title={item.title} description={item.description} />
        </div>
        <div className={twMerge("w-full lg:w-1/2 order-2", imageOrderClass)}>
          <ImageSection image={item.images[0]} title={item.title} />
        </div>
      </div>
    </div>
  )
}

const renderItem = (item, index) => (
  <FeatureLayout key={index} item={item} isImageRight={index % 2 === 1} />
)

const FeaturesBanners = ({ sections }) => {
  return (
    <div className="overflow-hidden">
      <CMSRender
        contentType="PageSection"
        match={{
          "content.name": {
            $in: sections,
          },
        }}
        renderItem={renderItem}
      />
    </div>
  )
}

export default FeaturesBanners
